var _jsxFileName = "/codebuild/output/src1718503544/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/steps/RegisterAccountForm.tsx";
import React, { useCallback, useState } from 'react';
import { Text } from '@adc/parallax-component-library';
import { LocalDate } from '@js-joda/core';
import { useAccount } from 'Hooks';
import { BirthdayInput, CountryBottomSheetModal, FormContainer, Input } from 'Components/utility';
import { GenderPicker } from 'Components/utility/GenderPicker';
import { SelectorInput } from 'Components/utility/SelectorInput';
import { getGenderDisplayText } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterAccountForm({
  formikForm,
  countries,
  isLLU
}) {
  const {
    validateDOBAndDisplayError
  } = useAccount();
  const [isGenderPickerVisible, setIsGenderPickerVisible] = useState(false);
  const [isPlaceOfBirthBottomSheetModalOpen, setIsPlaceOfBirthBottomSheetModalOpen] = useState(false);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldTouched,
    setFieldValue
  } = formikForm;
  const isFrench = values.country === 'FR';
  const handleDateChange = useCallback(date => {
    setFieldTouched('dateOfBirth');
    const dateString = date.toString();
    const isValid = validateDOBAndDisplayError(dateString);
    if (isValid) {
      setFieldValue('dateOfBirth', dateString);
    }
  }, [setFieldValue, setFieldTouched, validateDOBAndDisplayError]);
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.primaryText",
    nativeID: "CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.primaryText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.primaryText')), /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    testID: "firstName",
    inputMode: "text",
    errorMessage: errors.firstName,
    isInvalid: errors.firstName && touched.firstName ? true : false,
    value: values.firstName,
    onChangeText: handleChange('firstName'),
    onBlur: handleBlur('firstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    testID: "lastName",
    inputMode: "text",
    errorMessage: errors.lastName,
    isInvalid: errors.lastName && touched.lastName ? true : false,
    value: values.lastName,
    onChangeText: handleChange('lastName'),
    onBlur: handleBlur('lastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(BirthdayInput, {
    error: errors.dateOfBirth ? true : false,
    errorMessage: errors.dateOfBirth,
    isTouched: touched.dateOfBirth,
    initialDate: values.dateOfBirth ? LocalDate.parse(values.dateOfBirth) : undefined,
    onDateChange: handleDateChange,
    testID: "dateOfBirth",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }), isFrench && !isLLU && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectorInput, {
    testID: "gender",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    value: getGenderDisplayText(values.gender),
    onClick: () => setIsGenderPickerVisible(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 13
    }
  }, () => {
    return /*#__PURE__*/React.createElement(GenderPicker, {
      isOpen: isGenderPickerVisible,
      selectedGender: values.gender,
      onDone: gender => {
        setIsGenderPickerVisible(false);
        setFieldValue('gender', gender);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 122,
        columnNumber: 19
      }
    });
  }), /*#__PURE__*/React.createElement(SelectorInput, {
    testID: "birthCountry",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    value: values.birthCountry ? i18n.t(`Global.microcopy.countries.${values.birthCountry.toUpperCase()}`) : '',
    error: errors.birthCountry ? true : false,
    errorMessage: errors.birthCountry,
    isTouched: touched.birthCountry,
    onClick: () => setIsPlaceOfBirthBottomSheetModalOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 13
    }
  }, () => {
    return /*#__PURE__*/React.createElement(CountryBottomSheetModal, {
      title: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
      isOpen: isPlaceOfBirthBottomSheetModalOpen,
      onCancel: () => {
        setFieldTouched('birthCountry');
        setIsPlaceOfBirthBottomSheetModalOpen(false);
      },
      onDone: country => {
        if (country !== 'FR') {
          setFieldValue('birthZipCode', '');
        }
        setFieldValue('birthCountry', country);
        setIsPlaceOfBirthBottomSheetModalOpen(false);
      },
      selectedCountry: values.birthCountry,
      countries: countries,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 19
      }
    });
  })), values.birthCountry === 'FR' && /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    testID: "birthZipCode",
    inputMode: "numeric",
    errorMessage: errors.birthZipCode,
    isInvalid: errors.birthZipCode && touched.birthZipCode ? true : false,
    value: values.birthZipCode,
    onChangeText: handleChange('birthZipCode'),
    onBlur: handleBlur('birthZipCode'),
    maxLength: 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 11
    }
  })));
}
export { RegisterAccountForm };